<template>
  <div class="footer-index-content w100">
    <div class="main-width text-al">
      <div class="flex-between">
        <div class="first">
          <div class="footer-item-title blod">关于我们</div>
          <div class="footer-item-content-item" @click="toPage('clausesView')">
            <p class="under-line pointer">用户协议</p>
          </div>
          <div class="footer-item-content-item" @click="toPage('Statement')">
            <p class="under-line pointer">隐私政策</p>
          </div>
          <div class="footer-item-content-item" @click="toPage('paymentAgreement')">
            <p class="under-line pointer">会员服务协议</p>
          </div>
          <div class="footer-item-content-item" @click="toPage('renewalAgreement')">
            <p class="under-line pointer">自动续费协议</p>
          </div>
        </div>
        <div class="flexitem">
          <div class="footer-item-title blod">联系我们</div>
          <div class="footer-item-content-item">
            <a href="">Email：Trueshort@wemedia.cn</a>
          </div>
          <div class="footer-item-content-item">
            <!-- <a href="">Business Collaboartions</a>  -->
            <!-- // 商业合作 -->
          </div>
        </div>
        <!-- <div class="item-width">
          <div class="footer-item-title blod">Community</div>
          <div class="footer-item-content-item">
            <a href="">Tiktok</a>
          </div>
        </div> -->
      </div>
      <p class="footer-conpany-s text-al">
        © xinghejuchang，All Rights Reserved GUANGXI NANNING YOUJIN INFORMATION
        TECHNOLOGY CO., LTD.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    toPage(pageName) {
      if (this.$route.name != pageName)
        this.$router.push({
          name: pageName,
        });
    },
  },
};
</script>

<style scoped lang="less">
.footer-index-content {
  position: absolute;
  bottom: 0;
  color: #fff;
  left: 0;
  font-size: 14px;
  z-index: 999;
  padding: 30px 0 20px;
  background: #050b1c;
  .first {
    flex: 1;
  }
  .footer-item-title {
    font-size: 16px;
  }
  .footer-item-content-item {
    color: #f0f0f0;
  }
  .item-width {
    width: 200px;
  }
  .footer-conpany-s {
    margin-top: 30px;
  }
}
/* 适配 H5 和 PC */
@media (max-width: 768px) {
  .footer-index-content .footer-item-title {
    font-size: 12px;
  }
  .footer-item-content-item a {
    font-size: 10px;
  }
  .first {
    width: 30%;
  }
  .footer-conpany-s {
    font-size: 12px;
  }
}
</style>